"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(function () {
  var _React = React,
    useState = _React.useState,
    useEffect = _React.useEffect,
    useRef = _React.useRef,
    useMemo = _React.useMemo;

  // =========================================================================================
  // THE OBS TIMELINE: the patient's obs over the whole session, with what was done and what
  // changed, on one time axis. Shared by the debrief screen (dark, interactive) and the printed
  // report (light, static), so both always show the same chart.
  //
  // Form: small multiples. HR, BP, SpO2 and RR have different units, so each gets its own panel
  // and scale rather than sharing one y-axis. Above them, a rhythm lane (pulseless periods in
  // red, also washed across every panel); below them, numbered event markers in four labelled
  // lanes. Every marker number is in the event list under the chart, and every value is in the
  // obs table, so nothing depends on hovering or on colour alone.
  // =========================================================================================
  var escHtml = function escHtml(v) {
    return String(v === null || v === undefined ? '' : v).replace(/[&<>"']/g, function (c) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[c];
    });
  };
  var fmtClock = function fmtClock(s) {
    var t = Math.max(0, Math.round(Number(s) || 0));
    return "".concat(String(Math.floor(t / 60)).padStart(2, '0'), ":").concat(String(t % 60).padStart(2, '0'));
  };

  // Colours: series slot 1 (blue) and slot 2 (orange) from the validated categorical palette,
  // checked against these two surfaces; red and amber are the reserved status colours and
  // always come with a lane label and an icon. Text uses the ink tokens, never a series colour.
  var THEMES = {
    dark: {
      surface: '#020617',
      grid: '#1e293b',
      axis: '#334155',
      muted: '#94a3b8',
      secondary: '#cbd5e1',
      primary: '#f8fafc',
      line: '#3987e5',
      band: 'rgba(57,135,229,0.14)',
      action: '#3987e5',
      change: '#d95926',
      rhythm: '#d03b3b',
      flag: '#fab219',
      arrestWash: 'rgba(208,59,59,0.14)',
      perfusing: '#1e293b'
    },
    light: {
      surface: '#ffffff',
      grid: '#e2e8f0',
      axis: '#cbd5e1',
      muted: '#64748b',
      secondary: '#475569',
      primary: '#0f172a',
      line: '#2a78d6',
      band: 'rgba(42,120,214,0.10)',
      action: '#2a78d6',
      change: '#eb6834',
      rhythm: '#d03b3b',
      flag: '#fab219',
      arrestWash: 'rgba(208,59,59,0.09)',
      perfusing: '#eef2f7'
    }
  };
  // White or ink on a coloured marker, by the fill's luminance.
  var inkOn = function inkOn(hex) {
    var n = parseInt(hex.slice(1), 16);
    var r = n >> 16 & 255,
      g = n >> 8 & 255,
      b = n & 255;
    return 0.299 * r + 0.587 * g + 0.114 * b > 150 ? '#0f172a' : '#ffffff';
  };
  var EVENT_CATS = [{
    id: 'rhythm',
    label: 'Rhythm, arrest and shocks',
    icon: '⚡'
  }, {
    id: 'action',
    label: 'Team actions and treatment',
    icon: '●'
  }, {
    id: 'change',
    label: 'Facilitator changes',
    icon: '✎'
  }, {
    id: 'flag',
    label: 'Flags and warnings',
    icon: '⚑'
  }];
  // Which lane a log entry belongs in. Housekeeping (sync, settings, teaching notes typed 'info',
  // unflagged warnings such as "Defib charging") stays in the full log, off the graph.
  var classifyEvent = function classifyEvent(l) {
    var m = String(l.msg || '');
    if (/^Rhythm: .*→/.test(m) || /^CARDIAC ARREST/.test(m) || /^ROSC achieved/.test(m) || /^Shock delivered/.test(m) || /recurred after ROSC/i.test(m)) return 'rhythm';
    if (/^(Obs changed|Obs trend started|Patient Improving|Patient Deteriorating|Patient condition|Preset|Patient: |Sound: |NIBP cycled|NIBP Manual|Audio Loop|Facilitator override)/.test(m)) return 'change';
    // The facilitator's ventilator changes: problems injected/fixed, the lungs, the patient, the link and
    // remote settings. (A problem fixed by the team's own decompression or bronchoscopy is not one.)
    if (/^Ventilator \(facilitator\)|^Ventilator (link|patient)\b|^Ventilator (changed|shown|taken)\b.*\(facilitator\)|^Ventilator (problem|problems|lungs)\b.*\(facilitator\)/.test(m)) return 'change';
    if (l.flagged || l.deviation && Array.isArray(l.deviation.missing)) return 'flag';
    if (l.type === 'action' || l.type === 'success') return 'action';
    if (l.type === 'manual') return 'change'; // the facilitator's own log entries
    if (l.type === 'danger') return 'flag'; // timer alerts, failed airway
    return null;
  };
  var PANELS = [{
    key: 'hr',
    title: 'Heart rate',
    unit: 'bpm',
    dp: 0
  }, {
    key: 'bp',
    title: 'Blood pressure',
    unit: 'mmHg',
    dp: 0,
    low: 'bpDia'
  }, {
    key: 'spo2',
    title: 'SpO2',
    unit: '%',
    dp: 0
  }, {
    key: 'rr',
    title: 'Resp rate',
    unit: '/min',
    dp: 0
  }, {
    key: 'etco2',
    title: 'ETCO2',
    unit: 'kPa',
    dp: 1,
    onlyWhen: function onlyWhen(h) {
      return h.co2 === 1;
    }
  }, {
    key: 'temp',
    title: 'Temperature',
    unit: '°C',
    dp: 1,
    ifChanged: 0.25
  }, {
    key: 'bm',
    title: 'Glucose',
    unit: 'mmol/L',
    dp: 1,
    ifChanged: 0.6
  }, {
    key: 'ph',
    title: 'pH',
    unit: '',
    dp: 2,
    ifChanged: 0.02
  }, {
    key: 'gcs',
    title: 'GCS',
    unit: '',
    dp: 0,
    ifChanged: 0.5
  }];
  var numOf = function numOf(h, k) {
    var v = Number(h[k]);
    return h[k] === null || h[k] === undefined || !Number.isFinite(v) ? null : v;
  };
  var ceilTo = function ceilTo(v, step) {
    return Math.ceil(v / step) * step;
  };
  var domainFor = function domainFor(key, vals) {
    var hi0 = Math.max.apply(Math, _toConsumableArray(vals)),
      lo0 = Math.min.apply(Math, _toConsumableArray(vals));
    switch (key) {
      case 'hr':
        return [0, Math.max(160, ceilTo(hi0 * 1.1, 20))];
      case 'bp':
        return [0, Math.max(180, ceilTo(hi0 * 1.1, 20))];
      case 'spo2':
        return [Math.max(0, Math.min(80, Math.floor((lo0 - 5) / 10) * 10)), 100];
      case 'rr':
        return [0, Math.max(40, ceilTo(hi0 * 1.1, 10))];
      case 'etco2':
        return [0, Math.max(8, Math.ceil(hi0 + 1))];
      case 'temp':
        return [Math.min(34, Math.floor(lo0 - 0.5)), Math.max(40, Math.ceil(hi0 + 0.5))];
      case 'bm':
        return [0, Math.max(20, ceilTo(hi0 * 1.1, 5))];
      case 'ph':
        return [Math.min(6.9, Math.floor((lo0 - 0.05) * 10) / 10), Math.max(7.6, Math.ceil((hi0 + 0.05) * 10) / 10)];
      case 'gcs':
        return [3, 15];
      default:
        return [Math.min(0, lo0), hi0 || 1];
    }
  };
  var tickStep = function tickStep(span) {
    return [30, 60, 120, 300, 600, 900, 1800, 3600, 7200].find(function (s) {
      return span / s <= 7;
    }) || 7200;
  };

  // Lay out the whole chart for a given width. Returns the SVG markup plus the geometry the
  // interactive layer needs (null when fewer than two samples were recorded).
  var buildTimeline = function buildTimeline(history, log, opts) {
    var o = opts || {};
    var th = THEMES[o.theme === 'light' ? 'light' : 'dark'];
    var RG = window.RHYTHMS;
    var pts = (history || []).filter(function (h) {
      return h && Number.isFinite(Number(h.time));
    }).slice().sort(function (a, b) {
      return a.time - b.time;
    });
    if (pts.length < 2) return null;
    var events = (log || []).filter(function (l) {
      return l && Number.isFinite(Number(l.timeSeconds));
    }).map(function (l, i) {
      return {
        msg: String(l.msg || ''),
        simTime: l.simTime,
        t: Number(l.timeSeconds),
        cat: classifyEvent(l),
        order: i
      };
    }).filter(function (e) {
      return e.cat;
    }).sort(function (a, b) {
      return a.t - b.t || a.order - b.order;
    }).map(function (e, i) {
      return _objectSpread(_objectSpread({}, e), {}, {
        n: i + 1
      });
    });
    var t0 = Math.min.apply(Math, [pts[0].time].concat(_toConsumableArray(events.map(function (e) {
      return e.t;
    }))));
    var t1 = Math.max.apply(Math, [pts[pts.length - 1].time].concat(_toConsumableArray(events.map(function (e) {
      return e.t;
    }))));
    var span = Math.max(1, t1 - t0);
    var W = Math.max(320, Math.round(o.width || 720));
    var FS = o.theme === 'light' ? 12 : 11; // label size
    var L = 44,
      R = 64,
      plotW = W - L - R;
    var x = function x(t) {
      return L + (t - t0) / span * plotW;
    };
    var out = [];
    var text = function text(tx, ty, s, attrs) {
      return "<text x=\"".concat(tx.toFixed(1), "\" y=\"").concat(ty.toFixed(1), "\" font-size=\"").concat(attrs && attrs.size || FS, "\" fill=\"").concat(attrs && attrs.fill || th.muted, "\"").concat(attrs && attrs.anchor ? " text-anchor=\"".concat(attrs.anchor, "\"") : '').concat(attrs && attrs.weight ? " font-weight=\"".concat(attrs.weight, "\"") : '', ">").concat(escHtml(s), "</text>");
    };
    var y = 4;

    // Pulseless stretches, from the rhythm recorded in each sample.
    var segs = [];
    if (RG && pts.some(function (h) {
      return h.rhythm;
    })) {
      pts.forEach(function (h, i) {
        var end = i < pts.length - 1 ? pts[i + 1].time : t1;
        var r = h.rhythm || (segs.length ? segs[segs.length - 1].rhythm : null);
        if (!r) return;
        var last = segs[segs.length - 1];
        if (last && last.rhythm === r) last.end = end;else segs.push({
          rhythm: r,
          start: h.time,
          end: end,
          pulseless: RG.isPulseless(r)
        });
      });
    }
    var washes = segs.filter(function (s) {
      return s.pulseless && s.end > s.start;
    });

    // ---- Rhythm lane
    var rhythmLane = null;
    if (segs.length) {
      out.push(text(L, y + FS, 'Rhythm', {
        fill: th.primary,
        weight: 'bold',
        size: FS + 1
      }));
      y += FS + 6;
      var h = 20;
      segs.forEach(function (s) {
        var xa = x(s.start),
          xb = Math.max(xa + 1, x(s.end));
        var fill = s.pulseless ? th.rhythm : th.perfusing;
        var label = RG.labelFor(s.rhythm);
        var _short = RG.shortFor && RG.shortFor(s.rhythm) || label;
        out.push("<g><title>".concat(escHtml("".concat(label, ": ").concat(fmtClock(s.start), "\u2013").concat(fmtClock(s.end))), "</title><rect x=\"").concat(xa.toFixed(1), "\" y=\"").concat(y, "\" width=\"").concat(Math.max(1, xb - xa - 2).toFixed(1), "\" height=\"").concat(h, "\" rx=\"3\" fill=\"").concat(fill, "\"/></g>"));
        var fit = [label, _short].find(function (l) {
          return l.length * FS * 0.58 + 10 < xb - xa - 2;
        });
        if (fit) out.push(text(xa + 5, y + h / 2 + FS * 0.36, fit, {
          fill: s.pulseless ? '#ffffff' : th.primary,
          size: FS
        }));
      });
      rhythmLane = {
        top: y,
        bottom: y + h
      };
      y += h + 10;
    }

    // ---- Obs panels
    var plotTop = y;
    var panels = [];
    var PH = o.panelHeight || 58;
    PANELS.forEach(function (p) {
      var usable = pts.filter(function (h) {
        return (!p.onlyWhen || p.onlyWhen(h)) && numOf(h, p.key) !== null;
      });
      if (usable.length < 2) return;
      var vals = usable.map(function (h) {
        return numOf(h, p.key);
      }).concat(p.low ? usable.map(function (h) {
        return numOf(h, p.low);
      }).filter(function (v) {
        return v !== null;
      }) : []);
      if (p.ifChanged && Math.max.apply(Math, _toConsumableArray(vals)) - Math.min.apply(Math, _toConsumableArray(vals)) < p.ifChanged) return;
      var _domainFor = domainFor(p.key, vals),
        _domainFor2 = _slicedToArray(_domainFor, 2),
        lo = _domainFor2[0],
        hi = _domainFor2[1];
      var top = y + FS + 6,
        bottom = top + PH;
      var yOf = function yOf(v) {
        return bottom - (Math.min(Math.max(v, lo), hi) - lo) / (hi - lo) * PH;
      };
      out.push("<text x=\"".concat(L, "\" y=\"").concat(y + FS, "\" font-size=\"").concat(FS + 1, "\" font-weight=\"bold\" fill=\"").concat(th.primary, "\">").concat(escHtml(p.title)).concat(p.unit ? "<tspan font-weight=\"normal\" font-size=\"".concat(FS, "\" fill=\"").concat(th.muted, "\" dx=\"6\">").concat(escHtml(p.unit), "</tspan>") : '', "</text>"));
      washes.forEach(function (s) {
        return out.push("<rect x=\"".concat(x(s.start).toFixed(1), "\" y=\"").concat(top, "\" width=\"").concat(Math.max(1, x(s.end) - x(s.start)).toFixed(1), "\" height=\"").concat(PH, "\" fill=\"").concat(th.arrestWash, "\"/>"));
      });
      [lo, (lo + hi) / 2, hi].forEach(function (v) {
        out.push("<line x1=\"".concat(L, "\" x2=\"").concat(L + plotW, "\" y1=\"").concat(yOf(v).toFixed(1), "\" y2=\"").concat(yOf(v).toFixed(1), "\" stroke=\"").concat(v === lo ? th.axis : th.grid, "\" stroke-width=\"1\"/>"));
        out.push(text(L - 6, yOf(v) + FS * 0.35, Number(v).toFixed(p.dp === 2 ? 1 : p.dp && hi - lo < 20 ? 1 : 0), {
          anchor: 'end'
        }));
      });
      // A line broken wherever the value was not recorded (or capnography was off).
      var pathFor = function pathFor(key) {
        var d = '',
          pen = false;
        pts.forEach(function (h) {
          var v = !p.onlyWhen || p.onlyWhen(h) ? numOf(h, key) : null;
          if (v === null) {
            pen = false;
            return;
          }
          d += "".concat(pen ? 'L' : 'M').concat(x(h.time).toFixed(1), ",").concat(yOf(v).toFixed(1));
          pen = true;
        });
        return d;
      };
      if (p.low) {
        // BP: systolic and diastolic, with the pulse pressure as a light band between them.
        var both = pts.filter(function (h) {
          return numOf(h, p.key) !== null && numOf(h, p.low) !== null;
        });
        if (both.length > 1) {
          var band = both.map(function (h, i) {
            return "".concat(i ? 'L' : 'M').concat(x(h.time).toFixed(1), ",").concat(yOf(numOf(h, p.key)).toFixed(1));
          }).join('') + both.slice().reverse().map(function (h) {
            return "L".concat(x(h.time).toFixed(1), ",").concat(yOf(numOf(h, p.low)).toFixed(1));
          }).join('') + 'Z';
          out.push("<path d=\"".concat(band, "\" fill=\"").concat(th.band, "\" stroke=\"none\"/>"));
        }
        out.push("<path d=\"".concat(pathFor(p.low), "\" fill=\"none\" stroke=\"").concat(th.line, "\" stroke-width=\"2\" stroke-linejoin=\"round\" stroke-linecap=\"round\"/>"));
      }
      out.push("<path d=\"".concat(pathFor(p.key), "\" fill=\"none\" stroke=\"").concat(th.line, "\" stroke-width=\"2\" stroke-linejoin=\"round\" stroke-linecap=\"round\"/>"));
      // The last value, at the end of the line.
      var lastH = usable[usable.length - 1];
      var lastV = numOf(lastH, p.key);
      var lastLow = p.low ? numOf(lastH, p.low) : null;
      var fmt = function fmt(v) {
        return Number(v).toFixed(p.dp);
      };
      out.push("<circle cx=\"".concat(x(lastH.time).toFixed(1), "\" cy=\"").concat(yOf(lastV).toFixed(1), "\" r=\"4\" fill=\"").concat(th.line, "\" stroke=\"").concat(th.surface, "\" stroke-width=\"2\"/>"));
      out.push(text(L + plotW + 8, Math.min(bottom, Math.max(top + FS, yOf(lastV) + FS * 0.35)), lastLow !== null ? "".concat(fmt(lastV), "/").concat(fmt(lastLow)) : fmt(lastV), {
        fill: th.secondary,
        weight: 'bold'
      }));
      panels.push(_objectSpread(_objectSpread({}, p), {}, {
        top: top,
        bottom: bottom,
        yOf: yOf,
        lo: lo,
        hi: hi
      }));
      y = bottom + 10;
    });
    if (!panels.length) return null;
    var plotBottom = y - 10;

    // Rhythm events: a hairline through every panel, so the obs can be read against them.
    events.filter(function (e) {
      return e.cat === 'rhythm';
    }).forEach(function (e) {
      out.push("<line x1=\"".concat(x(e.t).toFixed(1), "\" x2=\"").concat(x(e.t).toFixed(1), "\" y1=\"").concat((rhythmLane ? rhythmLane.top : plotTop).toFixed(1), "\" y2=\"").concat(plotBottom.toFixed(1), "\" stroke=\"").concat(th.rhythm, "\" stroke-width=\"1\" stroke-opacity=\"0.55\"/>"));
    });

    // ---- Time axis
    var step = tickStep(span);
    for (var t = Math.ceil(t0 / step) * step; t <= t1 + 0.001; t += step) {
      out.push("<line x1=\"".concat(x(t).toFixed(1), "\" x2=\"").concat(x(t).toFixed(1), "\" y1=\"").concat(plotBottom, "\" y2=\"").concat(plotBottom + 4, "\" stroke=\"").concat(th.axis, "\" stroke-width=\"1\"/>"));
      out.push(text(x(t), plotBottom + 6 + FS, fmtClock(t), {
        anchor: 'middle'
      }));
    }
    y = plotBottom + FS + 16;

    // ---- Event lanes. Markers that would overlap in a lane share one marker ("12 +2").
    var lanes = [];
    EVENT_CATS.forEach(function (c) {
      var evs = events.filter(function (e) {
        return e.cat === c.id;
      });
      if (!evs.length) return;
      out.push(text(L, y + FS, "".concat(c.icon, " ").concat(c.label), {
        fill: th.secondary,
        weight: 'bold'
      }));
      var top = y + FS + 5,
        hgt = 18;
      var clusters = [];
      evs.forEach(function (e) {
        var ex = x(e.t);
        var c0 = clusters[clusters.length - 1];
        if (c0 && ex - 9 < c0.left + c0.width + 2) {
          c0.items.push(e);
        } else clusters.push({
          x: ex,
          items: [e]
        });
        var cl = clusters[clusters.length - 1];
        var label = cl.items.length === 1 ? String(cl.items[0].n) : "".concat(cl.items[0].n, " +").concat(cl.items.length - 1);
        cl.label = label;
        cl.width = Math.max(hgt, label.length * FS * 0.62 + 10);
        cl.left = Math.min(Math.max(0, cl.x - hgt / 2), W - cl.width);
      });
      var fill = th[c.id];
      clusters.forEach(function (cl) {
        var tip = cl.items.map(function (e) {
          return "".concat(e.n, ". ").concat(fmtClock(e.t), " ").concat(e.msg);
        }).join('\n');
        out.push("<g><title>".concat(escHtml(tip), "</title><rect x=\"").concat(cl.left.toFixed(1), "\" y=\"").concat(top, "\" width=\"").concat(cl.width.toFixed(1), "\" height=\"").concat(hgt, "\" rx=\"").concat(hgt / 2, "\" fill=\"").concat(fill, "\" stroke=\"").concat(th.surface, "\" stroke-width=\"2\"/>").concat(text(cl.left + cl.width / 2, top + hgt / 2 + FS * 0.36, cl.label, {
          anchor: 'middle',
          fill: inkOn(fill),
          weight: 'bold'
        }), "</g>"));
      });
      lanes.push({
        id: c.id,
        top: top,
        bottom: top + hgt
      });
      y = top + hgt + 8;
    });
    var H = Math.ceil(y + 4);
    var svg = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 ".concat(W, " ").concat(H, "\" width=\"").concat(W, "\" height=\"").concat(H, "\" role=\"img\" aria-label=\"").concat(escHtml(o.ariaLabel || 'The patient’s obs over the session, with the rhythm, what was done and what changed'), "\" style=\"display:block;max-width:100%;height:auto;font-family:system-ui,-apple-system,'Segoe UI',sans-serif;background:").concat(th.surface, "\"><rect width=\"").concat(W, "\" height=\"").concat(H, "\" fill=\"").concat(th.surface, "\"/>").concat(out.join(''), "</svg>");
    return {
      svg: svg,
      W: W,
      H: H,
      L: L,
      R: R,
      plotW: plotW,
      x: x,
      t0: t0,
      t1: t1,
      top: rhythmLane ? rhythmLane.top : plotTop,
      plotBottom: plotBottom,
      panels: panels,
      pts: pts,
      events: events,
      lanes: lanes,
      theme: th
    };
  };

  // Rows for the obs table: one per 30 s of session time, plus the last.
  var tableRows = function tableRows(pts) {
    var rows = [];
    var lastT = -Infinity;
    pts.forEach(function (h, i) {
      if (h.time - lastT >= 30 || i === pts.length - 1) {
        rows.push(h);
        lastT = h.time;
      }
    });
    return rows;
  };
  var cell = function cell(h, k, dp) {
    var v = numOf(h, k);
    return v === null ? '—' : v.toFixed(dp || 0);
  };
  var bpCell = function bpCell(h) {
    return numOf(h, 'bp') === null ? '—' : "".concat(cell(h, 'bp')).concat(numOf(h, 'bpDia') !== null ? '/' + cell(h, 'bpDia') : '');
  };
  var rhythmName = function rhythmName(r) {
    return r && window.RHYTHMS ? window.RHYTHMS.labelFor(r) : r || '—';
  };

  // ---- The printed / downloaded report: the same chart, light, with the event list and table.
  var buildReportTrend = function buildReportTrend(history, log) {
    var tl = buildTimeline(history, log, {
      theme: 'light',
      width: 940
    });
    if (!tl) {
      return "<div class=\"card\"><h3 style=\"margin-top:0;\">Obs, interventions and changes</h3><div class=\"muted\">Not enough obs were recorded for a graph (they are sampled every 5 seconds of session time).</div></div>";
    }
    var catOf = function catOf(id) {
      return EVENT_CATS.find(function (c) {
        return c.id === id;
      });
    };
    var eventList = tl.events.length ? "<ol class=\"events\">".concat(tl.events.map(function (e) {
      return "<li value=\"".concat(e.n, "\"><span class=\"mono\">").concat(escHtml(fmtClock(e.t)), "</span> <span class=\"chip\" style=\"background:").concat(tl.theme[e.cat], ";color:").concat(inkOn(tl.theme[e.cat]), "\">").concat(escHtml(catOf(e.cat).icon), " ").concat(escHtml(catOf(e.cat).label), "</span> ").concat(escHtml(e.msg), "</li>");
    }).join(''), "</ol>") : '<div class="muted">No interventions or changes were logged.</div>';
    var rows = tableRows(tl.pts);
    var table = "<table class=\"compact\"><thead><tr><th>Time</th><th>Rhythm</th><th>HR</th><th>BP</th><th>SpO2</th><th>RR</th><th>ETCO2</th><th>Temp</th><th>GCS</th></tr></thead><tbody>".concat(rows.map(function (h) {
      var _h$gcs;
      return "<tr><td class=\"mono\">".concat(fmtClock(h.time), "</td><td>").concat(escHtml(rhythmName(h.rhythm)), "</td><td>").concat(cell(h, 'hr'), "</td><td>").concat(bpCell(h), "</td><td>").concat(cell(h, 'spo2'), "</td><td>").concat(cell(h, 'rr'), "</td><td>").concat(h.co2 === 1 ? cell(h, 'etco2', 1) : '—', "</td><td>").concat(cell(h, 'temp', 1), "</td><td>").concat(escHtml((_h$gcs = h.gcs) !== null && _h$gcs !== void 0 ? _h$gcs : '—'), "</td></tr>");
    }).join(''), "</tbody></table>");
    return "<div class=\"card breakable\"><h3 style=\"margin-top:0;\">Obs, interventions and changes</h3><p class=\"muted\" style=\"margin-top:0;\">The patient\u2019s true obs every 5 seconds (what the team could see depended on what was attached). Red shading marks time without a pulse. The numbered markers match the list below.</p><div class=\"timeline\">".concat(tl.svg, "</div><h4>What happened</h4>").concat(eventList, "<h4>Obs every 30 seconds</h4>").concat(table, "</div>");
  };
  window.__debriefReportTrend = buildReportTrend; // test handle
  window.__buildObsTimeline = buildTimeline; // test handle

  // ---- The debrief screen: the same chart, dark, with a crosshair read-out and the event list.
  var ObsTimeline = function ObsTimeline(_ref) {
    var history = _ref.history,
      log = _ref.log,
      emptyText = _ref.emptyText;
    var wrapRef = useRef(null);
    var _useState = useState(720),
      _useState2 = _slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];
    var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      hover = _useState4[0],
      setHover = _useState4[1]; // index into tl.pts
    var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      ptrY = _useState6[0],
      setPtrY = _useState6[1]; // pointer height, for placing the read-out
    var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      picked = _useState8[0],
      setPicked = _useState8[1]; // event number
    var _useState9 = useState(false),
      _useState0 = _slicedToArray(_useState9, 2),
      showTable = _useState0[0],
      setShowTable = _useState0[1];
    useEffect(function () {
      var el = wrapRef.current;
      if (!el) return;
      var measure = function measure() {
        var w = Math.floor(el.clientWidth);
        if (w > 0) setWidth(w);
      };
      measure();
      if (typeof ResizeObserver === 'undefined') {
        window.addEventListener('resize', measure);
        return function () {
          return window.removeEventListener('resize', measure);
        };
      }
      var ro = new ResizeObserver(measure);
      ro.observe(el);
      return function () {
        return ro.disconnect();
      };
    }, []);
    var tl = useMemo(function () {
      return buildTimeline(history, log, {
        theme: 'dark',
        width: width
      });
    }, [history, log, width]);
    if (!tl) return /*#__PURE__*/React.createElement("div", {
      ref: wrapRef,
      className: "text-slate-400 text-xs p-4 text-center bg-slate-900 border border-slate-700 rounded mb-4",
      "data-testid": "obs-timeline-empty"
    }, emptyText);
    var nearest = function nearest(t) {
      var best = 0;
      tl.pts.forEach(function (h, i) {
        if (Math.abs(h.time - t) < Math.abs(tl.pts[best].time - t)) best = i;
      });
      return best;
    };
    var onMove = function onMove(e) {
      var rect = e.currentTarget.getBoundingClientRect();
      var px = (e.clientX - rect.left) * (tl.W / rect.width);
      if (px < tl.L - 4 || px > tl.L + tl.plotW + 4) return;
      setPtrY((e.clientY - rect.top) * (tl.W / rect.width));
      setHover(nearest(tl.t0 + (px - tl.L) / tl.plotW * (tl.t1 - tl.t0)));
    };
    var onKey = function onKey(e) {
      var last = tl.pts.length - 1;
      var cur = hover === null ? last : hover;
      var go = {
        ArrowLeft: Math.max(0, cur - 1),
        ArrowRight: Math.min(last, cur + 1),
        Home: 0,
        End: last
      }[e.key];
      if (go === undefined) return;
      e.preventDefault();
      setPtrY(null);
      setHover(go);
    };
    var h = hover !== null ? tl.pts[hover] : null;
    var pickedEv = picked !== null ? tl.events.find(function (ev) {
      return ev.n === picked;
    }) : null;
    var near = h ? tl.events.filter(function (ev) {
      return Math.abs(ev.t - h.time) <= 2.5;
    }) : [];
    var catOf = function catOf(id) {
      return EVENT_CATS.find(function (c) {
        return c.id === id;
      });
    };
    var readout = h ? [['HR', cell(h, 'hr'), 'bpm'], ['BP', bpCell(h), 'mmHg'], ['SpO2', cell(h, 'spo2'), '%'], ['RR', cell(h, 'rr'), '/min']].concat(_toConsumableArray(h.co2 === 1 ? [['ETCO2', cell(h, 'etco2', 1), 'kPa']] : []), _toConsumableArray(numOf(h, 'temp') !== null ? [['Temp', cell(h, 'temp', 1), '°C']] : []), _toConsumableArray(numOf(h, 'gcs') !== null ? [['GCS', cell(h, 'gcs'), '']] : [])) : [];
    // Beside the crosshair, on whichever side has room, and clear of the pointer.
    var tipLeft = h ? tl.x(h.time) + 232 > tl.W ? Math.max(0, tl.x(h.time) - 222) : tl.x(h.time) + 12 : 0;
    var tipTop = ptrY === null ? 4 : Math.max(4, Math.min(tl.H - 190, ptrY + 18));
    return /*#__PURE__*/React.createElement("div", {
      className: "w-full bg-slate-900 border border-slate-700 rounded p-3 mb-4",
      "data-testid": "obs-timeline"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "text-xs font-bold text-slate-300 mb-1 uppercase tracking-wide"
    }, "Obs, interventions and changes"), /*#__PURE__*/React.createElement("p", {
      className: "text-[11px] text-slate-400 mb-2"
    }, "The patient's true obs every 5 seconds. Red shading marks time without a pulse. Hover, or focus the chart and use the arrow keys, to read the values at any moment; the numbered markers match the list below."), /*#__PURE__*/React.createElement("div", {
      ref: wrapRef,
      className: "w-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "relative outline-none focus-visible:ring-2 focus-visible:ring-sky-500 rounded",
      tabIndex: 0,
      role: "group",
      "aria-label": "Obs timeline. Use the left and right arrow keys to step through the recorded obs.",
      onPointerMove: onMove,
      onPointerLeave: function onPointerLeave() {
        return setHover(null);
      },
      onKeyDown: onKey,
      onBlur: function onBlur() {
        return setHover(null);
      }
    }, /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: tl.svg
      }
    }), /*#__PURE__*/React.createElement("svg", {
      className: "absolute inset-0 pointer-events-none",
      viewBox: "0 0 ".concat(tl.W, " ").concat(tl.H),
      width: "100%",
      height: "100%",
      "aria-hidden": "true"
    }, pickedEv && /*#__PURE__*/React.createElement("line", {
      x1: tl.x(pickedEv.t),
      x2: tl.x(pickedEv.t),
      y1: tl.top,
      y2: tl.H - 4,
      stroke: tl.theme[pickedEv.cat],
      strokeWidth: "2"
    }), h && /*#__PURE__*/React.createElement("line", {
      x1: tl.x(h.time),
      x2: tl.x(h.time),
      y1: tl.top,
      y2: tl.plotBottom,
      stroke: "#e2e8f0",
      strokeWidth: "1"
    }), h && tl.panels.map(function (p) {
      var v = numOf(h, p.key);
      if (v === null || p.onlyWhen && !p.onlyWhen(h)) return null;
      return /*#__PURE__*/React.createElement("circle", {
        key: p.key,
        cx: tl.x(h.time),
        cy: p.yOf(v),
        r: "4",
        fill: tl.theme.line,
        stroke: tl.theme.surface,
        strokeWidth: "2"
      });
    })), h && /*#__PURE__*/React.createElement("div", {
      className: "absolute z-10 pointer-events-none bg-slate-800/95 border border-slate-600 rounded shadow-xl p-2 text-xs w-[210px]",
      style: {
        left: tipLeft,
        top: tipTop
      },
      "data-testid": "obs-readout"
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-mono text-slate-300 mb-0.5"
    }, fmtClock(h.time)), h.rhythm && /*#__PURE__*/React.createElement("div", {
      className: "text-slate-300 mb-1"
    }, rhythmName(h.rhythm)), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 gap-x-2"
    }, readout.map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 3),
        k = _ref3[0],
        v = _ref3[1],
        u = _ref3[2];
      return /*#__PURE__*/React.createElement("div", {
        key: k
      }, /*#__PURE__*/React.createElement("span", {
        className: "font-bold text-white font-mono"
      }, v), " ", /*#__PURE__*/React.createElement("span", {
        className: "text-slate-400"
      }, k, u ? " ".concat(u) : ''));
    })), near.length > 0 && /*#__PURE__*/React.createElement("ul", {
      className: "mt-1 border-t border-slate-600 pt-1 space-y-0.5"
    }, near.map(function (ev) {
      return /*#__PURE__*/React.createElement("li", {
        key: ev.n,
        className: "text-slate-200"
      }, /*#__PURE__*/React.createElement("b", null, ev.n, "."), " ", ev.msg);
    }))))), /*#__PURE__*/React.createElement("h5", {
      className: "text-[11px] font-bold text-slate-300 uppercase tracking-wide mt-3 mb-1"
    }, "What happened (", tl.events.length, ")"), tl.events.length === 0 ? /*#__PURE__*/React.createElement("div", {
      className: "text-xs text-slate-400"
    }, "No interventions or changes were logged.") : /*#__PURE__*/React.createElement("ol", {
      className: "max-h-56 overflow-y-auto space-y-0.5 pr-1",
      "data-testid": "obs-events"
    }, tl.events.map(function (ev) {
      return /*#__PURE__*/React.createElement("li", {
        key: ev.n
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: function onClick() {
          setPicked(picked === ev.n ? null : ev.n);
        },
        "aria-pressed": picked === ev.n,
        className: "w-full text-left flex gap-2 items-start text-xs rounded px-1 py-0.5 ".concat(picked === ev.n ? 'bg-slate-700' : 'hover:bg-slate-800')
      }, /*#__PURE__*/React.createElement("span", {
        className: "flex-none min-w-[1.6rem] text-center rounded-full font-bold text-[11px] leading-5",
        style: {
          background: tl.theme[ev.cat],
          color: inkOn(tl.theme[ev.cat])
        }
      }, ev.n), /*#__PURE__*/React.createElement("span", {
        className: "flex-none font-mono text-slate-400 leading-5"
      }, fmtClock(ev.t)), /*#__PURE__*/React.createElement("span", {
        className: "text-slate-200 leading-5"
      }, /*#__PURE__*/React.createElement("span", {
        className: "sr-only"
      }, catOf(ev.cat).label, ": "), ev.msg)));
    })), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return setShowTable(!showTable);
      },
      "aria-expanded": showTable,
      className: "mt-2 text-[11px] text-sky-400 underline"
    }, showTable ? 'Hide' : 'Show', " the obs as a table"), showTable && /*#__PURE__*/React.createElement("div", {
      className: "mt-1 max-h-56 overflow-auto"
    }, /*#__PURE__*/React.createElement("table", {
      className: "w-full text-[11px] text-slate-300 font-mono",
      "data-testid": "obs-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
      className: "text-slate-400 text-left"
    }, ['Time', 'Rhythm', 'HR', 'BP', 'SpO2', 'RR', 'ETCO2', 'Temp', 'GCS'].map(function (c) {
      return /*#__PURE__*/React.createElement("th", {
        key: c,
        className: "pr-2 font-bold"
      }, c);
    }))), /*#__PURE__*/React.createElement("tbody", null, tableRows(tl.pts).map(function (r) {
      var _r$gcs;
      return /*#__PURE__*/React.createElement("tr", {
        key: r.time,
        className: "border-t border-slate-800"
      }, /*#__PURE__*/React.createElement("td", {
        className: "pr-2"
      }, fmtClock(r.time)), /*#__PURE__*/React.createElement("td", {
        className: "pr-2 font-sans"
      }, rhythmName(r.rhythm)), /*#__PURE__*/React.createElement("td", {
        className: "pr-2"
      }, cell(r, 'hr')), /*#__PURE__*/React.createElement("td", {
        className: "pr-2"
      }, bpCell(r)), /*#__PURE__*/React.createElement("td", {
        className: "pr-2"
      }, cell(r, 'spo2')), /*#__PURE__*/React.createElement("td", {
        className: "pr-2"
      }, cell(r, 'rr')), /*#__PURE__*/React.createElement("td", {
        className: "pr-2"
      }, r.co2 === 1 ? cell(r, 'etco2', 1) : '—'), /*#__PURE__*/React.createElement("td", {
        className: "pr-2"
      }, cell(r, 'temp', 1)), /*#__PURE__*/React.createElement("td", {
        className: "pr-2"
      }, (_r$gcs = r.gcs) !== null && _r$gcs !== void 0 ? _r$gcs : '—'));
    })))));
  };
  var DebriefScreen = function DebriefScreen(_ref4) {
    var _progress$score, _progress$partialScor, _defibMetrics$lastEne2;
    var sim = _ref4.sim,
      onExit = _ref4.onExit,
      onReturn = _ref4.onReturn;
    var state = sim.state;
    var _window = window,
      Lucide = _window.Lucide,
      Button = _window.Button;
    var scenario = state.scenario || {};
    // QUICK SIM DEBRIEF. Quick Sim produces a real, lightweight debrief — event
    // log, vitals trend graph and instructor notes — but there is no scenario, so there are no
    // learning objectives to score and no score to show. Every scenario-dependent block below is
    // guarded, and `state.scenario` being null outright (an edge case that could previously
    // reach this screen via an aborted load) is handled by the `|| {}` above.
    // A Ventilator Sim saved before it stopped being built on Quick Sim still carries quickSim: true.
    var isQuickSim = !!scenario.quickSim && !scenario.ventSim;
    // Defib Sim: feedback in the standalone Defib-sim's style, and a printable certificate.
    var defibSim = scenario.defibSim && window.DefibSim && window.DefibSim.assess ? scenario.defibSim : null;
    var defibReview = defibSim ? window.DefibSim.assess(state) : null;
    // Ventilator feedback: any session in which a ventilator was used (Ventilator Sim or not).
    var ventSim = scenario.ventSim || null;
    var ventReview = window.VentSim && window.VentSim.used(state) ? window.VentSim.assess(state) : null;
    // The Live Skills Checklist (controller, Assessment tab): only the skills the facilitator marked.
    var skillMarks = Object.entries(state.assessments && _typeof(state.assessments) === 'object' ? state.assessments : {}).filter(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
        v = _ref6[1];
      return v === true || v === false;
    });
    var printCertificate = function printCertificate() {
      var name = window.prompt('Learner name for the certificate (leave blank to omit):', '');
      if (name === null) return;
      var html = window.DefibSim.certificateHtml(state, name.trim());
      var w = window.open('', '_blank');
      if (w && w.document) {
        w.document.open();
        w.document.write(html);
        w.document.close();
        var go = function go() {
          try {
            w.focus();
            w.print();
          } catch (e) {}
        };
        if (w.document.readyState === 'complete') setTimeout(go, 300);else w.addEventListener('load', function () {
          return setTimeout(go, 300);
        });
        return;
      }
      var blob = new Blob([html], {
        type: 'text/html'
      });
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = "Certificate_".concat(Date.now(), ".html");
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(function () {
        return URL.revokeObjectURL(url);
      }, 0);
    };
    var _useState1 = useState('all'),
      _useState10 = _slicedToArray(_useState1, 2),
      filter = _useState10[0],
      setFilter = _useState10[1];
    // The session's length on the debrief timeline (Quick Sim records it before START too).
    var duration = Number.isFinite(Number(state.sessionTime)) ? Math.max(Number(state.sessionTime), Number(state.time) || 0) : Number(state.time) || 0;
    var durationText = "".concat(Math.floor(duration / 60), "m ").concat(duration % 60, "s");
    var timelineEmpty = isQuickSim ? 'Not enough obs were recorded for a graph yet: they are sampled every 5 seconds from the moment the Quick Sim starts.' : defibSim ? "No obs were recorded: the graph records while the clock runs, which starts at the learner\u2019s first action on the defib (or when you press START)." : 'No obs were recorded: the graph records while the scenario clock runs, so press START at the beginning of the scenario.';
    // Keyed on state.runId — a genuinely unique id minted per RUN by the engine.
    // It used to read `state.sessionID`, which has never existed on state, so the key silently
    // collapsed to the SCENARIO id and every run of the same scenario shared one set of notes.
    // The remaining fallbacks only matter for a pre-Wave-4b saved session.
    var notesKey = "wmebem_debrief_notes_".concat(state.runId || scenario.id || 'current');
    var _useState11 = useState(function () {
        try {
          return localStorage.getItem(notesKey) || '';
        } catch (e) {
          return '';
        }
      }),
      _useState12 = _slicedToArray(_useState11, 2),
      instructorNotes = _useState12[0],
      setInstructorNotes = _useState12[1];
    useEffect(function () {
      try {
        localStorage.setItem(notesKey, instructorNotes);
      } catch (e) {}
    }, [notesKey, instructorNotes]);
    var filteredLog = state.log.filter(function (entry) {
      if (filter === 'all') return true;
      if (filter === 'actions') return entry.type === 'action';
      if (filter === 'manual') return entry.type === 'manual' || entry.flagged;
      if (filter === 'system') return entry.type === 'system';
      // The log filter had no way of showing 'danger'/'warning' entries at all, so shocks
      // and flagged deviations could not be isolated in the debrief.
      if (filter === 'shocks') return entry.type === 'danger' || /shock|defib|cardiovers/i.test(entry.msg || '');
      if (filter === 'rhythm') return /^Rhythm:/i.test(entry.msg || '') || /ROSC|CARDIAC ARREST/i.test(entry.msg || '');
      return true;
    });

    // ---- B5: SHOCK METRICS IN THE DEBRIEF ------------------------------------------------
    // These now exist because Wave 3 moved the shock tally out of a bare useRef (which never
    // reached state, Firebase, localStorage or this screen, and reset on resume) into
    // state.defib, which is synced and persisted.
    var defibMetrics = state.defib || {};
    var shockEvents = state.log.filter(function (l) {
      return l.type === 'danger' && /shock delivered/i.test(l.msg || '');
    });
    var conversionEvents = state.log.filter(function (l) {
      return /^Rhythm:/.test(l.msg || '') && /\u2192/.test(l.msg || '');
    });
    // The Defibrillation summary is shown only when a shock was given (any mode).
    var shockTotal = Number(defibMetrics.shockCount) || shockEvents.length || 0;
    var simMode = ventSim ? 'Ventilator Sim' : defibSim ? 'Defib Sim' : isQuickSim ? 'Quick Sim' : null;
    var simModeDetail = ventSim ? "".concat(ventSim.name, " \xB7 ").concat(ventSim.mode === 'assessment' ? 'Assessment' : 'Education', " mode") : defibSim ? "".concat(defibSim.name, " \xB7 ").concat(defibSim.mode === 'assessment' ? 'Assessment' : 'Education', " mode") : isQuickSim ? "No scenario \u2014 nothing to score" : '';

    // Sequence deviations: structured records written by the engine's permissive gating. Nothing
    // was blocked during the session; these are the teaching points that fell out of it.
    var deviations = state.log.filter(function (l) {
      return l.deviation && Array.isArray(l.deviation.missing);
    });
    // `flagged` marks BOTH deviations and merely-significant events (arrests,
    // shocks, hand flags). The two counts are now reported separately and labelled, so neither
    // screen shows a deviation count that disagrees with the deviation list.
    var flaggedCount = state.log.filter(function (l) {
      return l.flagged;
    }).length;
    var significanceCount = flaggedCount - deviations.length;
    var allObjectives = function (_scenario$instructorB) {
      // No scenario means no objectives. Array.isArray guards a restricted/pasted scenario
      // that carries a malformed learningObjectives field.
      var a = Array.isArray(scenario.learningObjectives) ? scenario.learningObjectives : [];
      var b = Array.isArray((_scenario$instructorB = scenario.instructorBrief) === null || _scenario$instructorB === void 0 ? void 0 : _scenario$instructorB.learningObjectives) ? scenario.instructorBrief.learningObjectives : [];
      var seen = new Set();
      return [].concat(_toConsumableArray(a), _toConsumableArray(b)).filter(function (o) {
        if (seen.has(o)) return false;
        seen.add(o);
        return true;
      });
    }();
    var objectivesTotal = allObjectives.length;
    var completed = state.completedObjectives instanceof Set ? state.completedObjectives : new Set();
    // ---- WAVE 5 / ITEM 2: PARTIAL CREDIT ON MULTI-COMPONENT OBJECTIVES --------------------
    // "Hyperkalaemia treatment" needs calcium AND insulin/dextrose. Giving only calcium used to
    // read "0% — Objectives Met: 0/1", which a facilitator reasonably mistakes for a bug. The
    // engine now derives each objective's COMPONENTS from the scenario's own recommended actions
    // and reports which were done and which were missing. Scores are not inflated: the headline
    // number still counts only fully-completed objectives, and the partial-credit number is
    // shown next to it, explicitly labelled.
    var progress = window.computeObjectiveProgress ? window.computeObjectiveProgress(state.scenario || {}, {
      interventionCounts: state.interventionCounts,
      // Kit already on at set-up (data/engine.js setUpIntervention) is not the team's.
      activeInterventions: new Set(_toConsumableArray(state.activeInterventions || []).filter(function (k) {
        return !(state.scenario && state.scenario.setupKit || []).includes(k);
      })),
      completedObjectives: completed
    }) : {
      objectives: [],
      total: objectivesTotal,
      fullyMet: 0,
      partial: 0,
      score: null,
      partialScore: null,
      hasPartial: false
    };
    var objectiveRows = progress.objectives || [];
    var objectivesMet = progress.fullyMet;
    // A score of "100%" against zero objectives is meaningless and actively misleading in Quick
    // Sim, so the score is null when there is nothing to score and the card is omitted.
    var score = objectivesTotal > 0 ? (_progress$score = progress.score) !== null && _progress$score !== void 0 ? _progress$score : 0 : null;
    var partialScore = objectivesTotal > 0 ? (_progress$partialScor = progress.partialScore) !== null && _progress$partialScor !== void 0 ? _progress$partialScor : 0 : null;
    var partialCount = progress.partial || 0;
    var statusOf = function statusOf(obj) {
      var row = objectiveRows.find(function (r) {
        return r.objective === obj;
      });
      return row || {
        objective: obj,
        status: completed.has(obj) ? 'met' : 'none',
        components: [],
        metComponents: [],
        missingComponents: [],
        multiComponent: false,
        facilitatorJudged: true
      };
    };
    // Recognition, judgement and communication objectives cannot be scored from what was given,
    // so the facilitator ticks them here (pressing again removes the tick).
    var toggleObjective = function toggleObjective(obj) {
      if (sim && typeof sim.dispatch === 'function') sim.dispatch({
        type: 'TOGGLE_OBJECTIVE',
        payload: obj
      });
    };

    // Leaving the debrief loses it, so ask first unless the report has been saved or printed.
    var savedRef = useRef(false);
    // Course mark sheet (restricted course scenarios): A / N per criterion, kept for this debrief.
    var MS = window.MarkScheme;
    var _useState13 = useState({}),
      _useState14 = _slicedToArray(_useState13, 2),
      sheetMarks = _useState14[0],
      setSheetMarks = _useState14[1];
    var markSheetItem = function markSheetItem(id, v) {
      return setSheetMarks(function (m) {
        var n = _objectSpread({}, m);
        if (v) n[id] = v;else delete n[id];
        return n;
      });
    };
    var hasMarkSheet = !!(MS && MS.get(scenario) && MS.items(scenario).length);
    var exitDebrief = function exitDebrief() {
      if (savedRef.current || window.confirm('Leave the debrief? It cannot be reopened. Download or print the report first if you want to keep it.')) onExit();
    };
    var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      pdfBusy = _useState16[0],
      setPdfBusy = _useState16[1];
    var generateReport = function generateReport(mode) {
      var _defibMetrics$lastEne;
      if (mode === 'download' && pdfBusy) return;
      savedRef.current = true;
      var esc = function esc(value) {
        return String(value !== null && value !== void 0 ? value : '').replace(/[&<>'"]/g, function (_char) {
          return {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            "'": '&#39;',
            '"': '&quot;'
          }[_char];
        });
      };
      // The report shows the same three-state status and names the components
      // that were and were not done, so a partial objective is never printed as a bare failure.
      var objRows = allObjectives.map(function (obj) {
        var r = statusOf(obj);
        var colour = r.status === 'met' ? '#22c55e' : r.status === 'partial' ? '#fbbf24' : '#ef4444';
        var label = r.status === 'met' ? "\u2713 Met" : r.status === 'partial' ? "\u25D0 Partly done" : "\u2715 Not Met";
        var detail = r.components && r.components.length ? "".concat(r.metComponents.length ? 'Done: ' + esc(r.metComponents.join(', ')) : '').concat(r.metComponents.length && r.missingComponents.length ? '<br>' : '').concat(r.missingComponents.length ? 'Not done: ' + esc(r.missingComponents.join(', ')) : '') : "<span style=\"color:#64748b;\">Facilitator judgement".concat(r.status === 'met' ? ': ticked as demonstrated' : ': not ticked', " (not scored from actions).</span>");
        return "<tr><td style=\"padding:6px 10px;border-bottom:1px solid #334155;\">".concat(esc(obj), "</td><td style=\"padding:6px 10px;border-bottom:1px solid #334155;color:").concat(colour, ";font-weight:bold;white-space:nowrap;\">").concat(label, "</td><td style=\"padding:6px 10px;border-bottom:1px solid #334155;color:#cbd5e1;font-size:.85rem;\">").concat(detail, "</td></tr>");
      }).join('');
      var logRows = state.log.map(function (l) {
        var colour = l.type === 'danger' ? '#ef4444' : l.type === 'success' ? '#22c55e' : '#cbd5e1';
        return "<tr><td style=\"padding:5px 10px;border-bottom:1px solid #1e293b;color:#94a3b8;font-family:monospace;white-space:nowrap;\">".concat(esc(l.simTime), "</td><td style=\"padding:5px 10px;border-bottom:1px solid #1e293b;color:").concat(colour, ";\">").concat(l.flagged ? "\uD83D\uDEA9 " : '').concat(esc(l.msg), "</td></tr>");
      }).join('');
      var devRows = deviations.map(function (d) {
        return "<tr><td style=\"padding:5px 10px;border-bottom:1px solid #1e293b;color:#94a3b8;font-family:monospace;white-space:nowrap;\">".concat(esc(d.simTime), "</td><td style=\"padding:5px 10px;border-bottom:1px solid #1e293b;color:#fbbf24;font-weight:bold;\">").concat(esc(d.deviation.label || d.deviation.action), "</td><td style=\"padding:5px 10px;border-bottom:1px solid #1e293b;color:#cbd5e1;\">").concat(esc(d.deviation.missing.join(', ')), "</td></tr>");
      }).join('');
      var shockRows = shockEvents.map(function (l) {
        return "<tr><td style=\"padding:5px 10px;border-bottom:1px solid #1e293b;color:#94a3b8;font-family:monospace;white-space:nowrap;\">".concat(esc(l.simTime), "</td><td style=\"padding:5px 10px;border-bottom:1px solid #1e293b;color:#fca5a5;\">").concat(esc(l.msg), "</td></tr>");
      }).join('');
      var convRows = conversionEvents.map(function (l) {
        return "<tr><td style=\"padding:5px 10px;border-bottom:1px solid #1e293b;color:#94a3b8;font-family:monospace;white-space:nowrap;\">".concat(esc(l.simTime), "</td><td style=\"padding:5px 10px;border-bottom:1px solid #1e293b;color:#fbbf24;\">").concat(esc(l.msg), "</td></tr>");
      }).join('');
      // Defibrillation data reaches the downloadable debrief report too.
      // Omitted when no shock was given; rhythm transitions on their own still get a card.
      var defibCard = !shockTotal ? convRows ? "<div class=\"card\"><h3 style=\"color:#fbbf24;margin-top:0;\">Rhythm transitions</h3><table><thead><tr><th>Time</th><th>Transition</th></tr></thead><tbody>".concat(convRows, "</tbody></table></div>") : '' : "<div class=\"card\"><h3 style=\"color:#ef4444;margin-top:0;\">Defibrillation &amp; Rhythm</h3><div style=\"display:flex;gap:24px;flex-wrap:wrap;margin-bottom:12px;\"><div><div style=\"font-size:.7rem;color:#64748b;text-transform:uppercase;\">Shocks</div><div style=\"font-size:1.5rem;font-weight:bold;\">".concat(esc(shockTotal), "</div></div><div><div style=\"font-size:.7rem;color:#64748b;text-transform:uppercase;\" title=\"Shocks into a shockable rhythm, not counting a shock stacked within 5 s of the last\">Counted towards ROSC</div><div style=\"font-size:1.5rem;font-weight:bold;\">").concat(esc(defibMetrics.shockableShocks || 0), "</div></div><div><div style=\"font-size:.7rem;color:#64748b;text-transform:uppercase;\">Cumulative energy</div><div style=\"font-size:1.5rem;font-weight:bold;\">").concat(esc(defibMetrics.totalEnergy || 0), " J</div></div><div><div style=\"font-size:.7rem;color:#64748b;text-transform:uppercase;\">Last energy</div><div style=\"font-size:1.5rem;font-weight:bold;\">").concat(esc((_defibMetrics$lastEne = defibMetrics.lastEnergy) !== null && _defibMetrics$lastEne !== void 0 ? _defibMetrics$lastEne : '--'), " J</div></div></div>").concat(shockRows ? "<table><thead><tr><th>Time</th><th>Shock</th></tr></thead><tbody>".concat(shockRows, "</tbody></table>") : '<div style="color:#94a3b8;">No shocks delivered.</div>').concat(convRows ? "<h4 style=\"color:#fbbf24;\">Rhythm transitions</h4><table><thead><tr><th>Time</th><th>Transition</th></tr></thead><tbody>".concat(convRows, "</tbody></table>") : '', "</div>");
      var devCard = "<div class=\"card\"><h3 style=\"color:#fbbf24;margin-top:0;\">Sequence Deviations</h3>".concat(deviations.length ? "<table><thead><tr><th>Time</th><th>Action</th><th>Not in place</th></tr></thead><tbody>".concat(devRows, "</tbody></table>") : '<div style="color:#94a3b8;">No sequence deviations recorded.</div>', "</div>");
      var safeTitle = esc(scenario.title || 'Simulation');
      // The objectives card and the score are omitted from the downloadable report when
      // there are no objectives, rather than printing "100% of 0".
      var scoreBlock = score === null ? "<div><div style=\"font-size:.75rem;color:#64748b;text-transform:uppercase;\">Mode</div><div style=\"font-size:1.5rem;font-weight:bold;\">".concat(esc(simMode || 'Scenario'), "</div><div style=\"font-size:.7rem;color:#64748b;\">").concat(esc(simModeDetail || "No learning objectives \u2014 nothing to score"), "</div></div>") : "<div><div style=\"font-size:.75rem;color:#64748b;text-transform:uppercase;\">Score (fully met)</div><div class=\"score\">".concat(esc(score), "%</div></div><div><div style=\"font-size:.75rem;color:#64748b;text-transform:uppercase;\">Objectives Met</div><div style=\"font-size:1.5rem;font-weight:bold;\">").concat(esc(objectivesMet), " / ").concat(esc(objectivesTotal), "</div>").concat(partialCount ? "<div style=\"font-size:.7rem;color:#fbbf24;\">+ ".concat(esc(partialCount), " partly done</div>") : '', "</div>").concat(partialCount ? "<div><div style=\"font-size:.75rem;color:#64748b;text-transform:uppercase;\">With partial credit</div><div style=\"font-size:1.5rem;font-weight:bold;color:#fbbf24;\">".concat(esc(partialScore), "%</div><div style=\"font-size:.7rem;color:#64748b;\">components done / components expected</div></div>") : '');
      var objCard = objectivesTotal === 0 ? '' : "<div class=\"card\"><h3 style=\"color:#a78bfa;margin-top:0;\">Learning Objectives</h3><p style=\"color:#94a3b8;font-size:.8rem;margin-top:0;\">Objectives made of more than one component are only \u201Cmet\u201D when every component was done. Anything started but incomplete is shown as partly done, with the missing component named \u2014 a low score here is a discussion point, not a verdict.</p><table><thead><tr><th>Objective</th><th>Status</th><th>Components</th></tr></thead><tbody>".concat(objRows, "</tbody></table></div>");
      // Light, print-friendly theme (it used to be dark, which printed as solid black pages).
      // The inline colours inside the cards were written for a dark background, so the CSS
      // re-maps the light-on-dark ones to readable ink.
      var reportCss = "body{font-family:Arial,sans-serif;background:#fff;color:#0f172a;margin:0;padding:24px;max-width:1000px}h1{color:#0369a1;margin-bottom:4px}h2{color:#475569;font-size:1rem;font-weight:normal;margin-bottom:24px}h3{color:#0f172a!important}h4{margin:14px 0 6px;color:#334155}.card{background:#fff;border-radius:8px;padding:16px;margin-bottom:16px;border:1px solid #cbd5e1;break-inside:avoid}.card.breakable{break-inside:auto}.mini,.timeline,tr{break-inside:avoid}.score{font-size:3rem;font-weight:bold;color:#0369a1}table{width:100%;border-collapse:collapse}th{text-align:left;padding:8px 10px;color:#475569;font-size:.75rem;text-transform:uppercase;letter-spacing:.05em;border-bottom:2px solid #cbd5e1}td{color:#0f172a!important;border-bottom:1px solid #e2e8f0!important}.muted{color:#64748b;font-size:.85rem}.mono{font-family:monospace;color:#475569}.minis{display:grid;grid-template-columns:1fr 1fr;gap:8px}.mini{margin:0;border:1px solid #e2e8f0;border-radius:6px;padding:4px}.mini svg{width:100%;height:auto;display:block}.events{margin:0;padding-left:28px;font-size:.85rem}.events li{margin:2px 0}.chip{display:inline-block;border-radius:9px;padding:0 6px;font-size:.7rem;font-weight:bold;margin-right:4px}.timeline{overflow:hidden;margin:8px 0}.timeline svg{width:100%;height:auto;display:block}table.compact td,table.compact th{padding:3px 8px;font-size:.8rem}@media (max-width:640px){.minis{grid-template-columns:1fr}}@media print{body{padding:0}.card{border-color:#94a3b8}a{color:inherit}}";
      var trendCard = buildReportTrend(state.history, state.log);
      var defibFeedbackCard = defibReview ? "<div class=\"card\"><h3 style=\"margin-top:0;\">Defib Sim feedback</h3><p class=\"muted\" style=\"margin-top:0;\">".concat(esc(defibSim.name), " &middot; ").concat(defibSim.mode === 'assessment' ? 'Assessment' : 'Education', " mode</p>").concat(defibReview.outcome ? "<p><b>".concat(esc(defibReview.outcome.title), ".</b> ").concat(esc(defibReview.outcome.text), "</p>") : '').concat(defibReview.good.length ? "<h4>Good practice</h4><ul>".concat(defibReview.good.map(function (g) {
        return "<li>".concat(esc(g), "</li>");
      }).join(''), "</ul>") : '').concat(defibReview.improve.length ? "<h4>Areas for improvement</h4><ul>".concat(defibReview.improve.map(function (g) {
        return "<li>".concat(esc(g), "</li>");
      }).join(''), "</ul>") : '', "</div>") : '';
      var li = function li(arr) {
        return arr.map(function (g) {
          return "<li>".concat(esc(g), "</li>");
        }).join('');
      };
      var ventFeedbackCard = ventReview ? "<div class=\"card\"><h3 style=\"margin-top:0;\">Ventilator feedback</h3>".concat(ventSim ? "<p class=\"muted\" style=\"margin-top:0;\">".concat(esc(ventSim.name), " &middot; ").concat(ventSim.mode === 'assessment' ? 'Assessment' : 'Education', " mode</p>") : '').concat(ventReview.stats.length ? "<ul>".concat(li(ventReview.stats), "</ul>") : '').concat(ventReview.good.length ? "<h4>Good practice</h4><ul>".concat(li(ventReview.good), "</ul>") : '').concat(ventReview.improve.length ? "<h4>Areas for improvement</h4><ul>".concat(li(ventReview.improve), "</ul>") : '').concat(ventReview.problems.length ? "<h4>Problems</h4><ul>".concat(li(ventReview.problems.map(function (p) {
        return p.text;
      })), "</ul>") : '', "</div>") : '';
      var skillsCard = skillMarks.length ? "<div class=\"card\"><h3 style=\"margin-top:0;\">Skills checklist</h3><table class=\"compact\"><thead><tr><th>Skill</th><th>Marked</th></tr></thead><tbody>".concat(skillMarks.map(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
          k = _ref8[0],
          v = _ref8[1];
        return "<tr><td>".concat(esc(k), "</td><td>").concat(v ? 'Observed' : 'Needs improvement', "</td></tr>");
      }).join(''), "</tbody></table></div>") : '';
      var markSheetCard = hasMarkSheet ? "<div class=\"card\"><h3 style=\"margin-top:0;\">".concat(MS.get(scenario).kind === 'assessment' ? 'Team leader assessment' : 'Mark sheet', "</h3>").concat(MS.criteriaHtml(scenario, sheetMarks), "</div>") : '';
      var html = "<!DOCTYPE html><html lang=\"en-GB\"><head><meta charset=\"UTF-8\"><title>Debrief \u2014 ".concat(safeTitle, "</title><style>").concat(reportCss, "</style></head><body><h1>").concat(safeTitle, "</h1><h2>Simulation Debrief Report &nbsp;&bull;&nbsp; ").concat(esc(new Date().toLocaleString('en-GB')), "</h2><div class=\"card\"><div style=\"display:flex;align-items:center;gap:24px;flex-wrap:wrap;\">").concat(scoreBlock, "<div><div style=\"font-size:.75rem;color:#64748b;text-transform:uppercase;\">Duration</div><div style=\"font-size:1.5rem;font-weight:bold;\">").concat(esc(durationText), "</div></div></div></div>").concat(defibFeedbackCard).concat(ventFeedbackCard).concat(markSheetCard).concat(skillsCard).concat(objCard).concat(trendCard).concat(devCard).concat(defibCard, "<div class=\"card breakable\"><h3 style=\"color:#38bdf8;margin-top:0;\">Simulation Log</h3><table><thead><tr><th>Time</th><th>Event</th></tr></thead><tbody>").concat(logRows, "</tbody></table></div><div class=\"card\"><h3 style=\"color:#fbbf24;margin-top:0;\">Instructor Notes</h3><div style=\"white-space:pre-wrap;\">").concat(esc(instructorNotes), "</div></div></body></html>");
      if (mode === 'print') {
        // Opened from the click itself, so popup blockers allow it. If one still blocks it,
        // fall back to downloading the same file.
        var w = window.open('', '_blank');
        if (w && w.document) {
          w.document.open();
          w.document.write(html);
          w.document.close();
          var go = function go() {
            try {
              w.focus();
              w.print();
            } catch (e) {}
          };
          if (w.document.readyState === 'complete') setTimeout(go, 300);else w.addEventListener('load', function () {
            return setTimeout(go, 300);
          });
          return;
        }
      }
      var downloadHtml = function downloadHtml() {
        var blob = new Blob([html], {
          type: 'text/html'
        });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = "Debrief_".concat(Date.now(), ".html");
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(function () {
          return URL.revokeObjectURL(url);
        }, 0);
      };
      // The download is a PDF (data/report-pdf.js). If the PDF cannot be made (the libraries
      // fail to load offline on a first visit, an old browser), the same report is saved as a
      // web page instead, as it used to be.
      if (mode === 'download' && typeof window.reportToPdf === 'function') {
        var d = new Date();
        var p2 = function p2(n) {
          return String(n).padStart(2, '0');
        };
        var stamp = "".concat(d.getFullYear(), "-").concat(p2(d.getMonth() + 1), "-").concat(p2(d.getDate()), " ").concat(p2(d.getHours())).concat(p2(d.getMinutes()));
        setPdfBusy(true);
        window.reportToPdf(html, "Debrief - ".concat(scenario.title || 'Simulation', " - ").concat(stamp, ".pdf"))["catch"](function (e) {
          console.warn('PDF report failed, saving as a web page instead', e);
          downloadHtml();
        })["finally"](function () {
          return setPdfBusy(false);
        });
        return;
      }
      downloadHtml();
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "h-full flex flex-col bg-slate-900 p-4 overflow-hidden max-lg:h-auto max-lg:overflow-visible max-md:p-3",
      "data-testid": "debrief-screen"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center gap-3 mb-4 border-b border-slate-700 pb-4 max-md:flex-col max-md:items-stretch"
    }, /*#__PURE__*/React.createElement("div", {
      className: "min-w-0"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "text-2xl max-md:text-xl font-bold text-white flex items-center gap-2"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "check-circle",
      className: "text-emerald-500"
    }), " Simulation Complete"), /*#__PURE__*/React.createElement("p", {
      className: "text-slate-400"
    }, scenario.title || 'Simulation', isQuickSim && /*#__PURE__*/React.createElement("span", {
      className: "ml-2 text-[10px] uppercase tracking-wider font-bold text-sky-400 border border-sky-700 bg-sky-950/40 rounded px-1.5 py-0.5"
    }, "Quick Sim \xB7 no scenario"), ventSim && /*#__PURE__*/React.createElement("span", {
      className: "ml-2 text-[10px] uppercase tracking-wider font-bold text-cyan-300 border border-cyan-700 bg-cyan-950/40 rounded px-1.5 py-0.5",
      "data-testid": "vent-sim-badge"
    }, "Ventilator Sim \xB7 ", ventSim.mode === 'assessment' ? 'Assessment' : 'Education'), ' ', "\u2022 Duration: ", durationText)), /*#__PURE__*/React.createElement("div", {
      className: "flex gap-2 flex-none max-md:grid max-md:grid-cols-2",
      "data-testid": "debrief-actions"
    }, onReturn && /*#__PURE__*/React.createElement(Button, {
      onClick: onReturn,
      variant: "outline",
      className: "whitespace-nowrap",
      ariaLabel: "Back to scenario"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "arrow-left",
      className: "mr-2 h-4 w-4"
    }), " Back to scenario"), defibSim && /*#__PURE__*/React.createElement(Button, {
      onClick: printCertificate,
      variant: "secondary",
      className: "whitespace-nowrap",
      title: "Print a certificate of completion for the learner"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "check-circle",
      className: "mr-2 h-4 w-4"
    }), " Certificate"), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return generateReport('print');
      },
      variant: "secondary",
      className: "whitespace-nowrap",
      title: "Open a print-friendly report and print it (or save as PDF)"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "printer",
      className: "mr-2 h-4 w-4"
    }), " Print"), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return generateReport('download');
      },
      variant: "secondary",
      className: "whitespace-nowrap",
      disabled: pdfBusy
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "download",
      className: "mr-2 h-4 w-4"
    }), " ", pdfBusy ? "Making PDF\u2026" : 'Download PDF'), /*#__PURE__*/React.createElement(Button, {
      onClick: exitDebrief,
      variant: "secondary",
      className: "whitespace-nowrap"
    }, "Exit to Menu"))), /*#__PURE__*/React.createElement("div", {
      className: "flex-1 grid grid-cols-1 lg:grid-cols-2 gap-4 overflow-hidden min-h-0 max-lg:flex-none max-lg:overflow-visible"
    }, /*#__PURE__*/React.createElement("div", {
      className: "overflow-y-auto space-y-4 pr-2 min-w-0 max-lg:overflow-visible max-lg:pr-0"
    }, /*#__PURE__*/React.createElement(ObsTimeline, {
      history: state.history,
      log: state.log,
      emptyText: timelineEmpty
    }), defibReview && /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-4 rounded-lg border border-amber-700/60",
      "data-testid": "defib-feedback"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-white mb-1 flex items-center gap-2"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "zap",
      className: "w-4 h-4 text-amber-400"
    }), " Defib Sim feedback"), /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-slate-400 mb-3"
    }, defibSim.name, " \xB7 ", defibSim.mode === 'assessment' ? 'Assessment' : 'Education', " mode"), defibReview.outcome && /*#__PURE__*/React.createElement("div", {
      className: "mb-3 p-2 rounded border ".concat(defibReview.outcome.ok ? 'border-emerald-600 bg-emerald-950/40 text-emerald-300' : 'border-amber-600 bg-amber-950/40 text-amber-300')
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-bold"
    }, defibReview.outcome.ok ? "\u2713" : "\u26A0", " ", defibReview.outcome.title), /*#__PURE__*/React.createElement("div", {
      className: "text-xs text-slate-300"
    }, defibReview.outcome.text)), defibReview.good.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "mb-2 border-l-4 border-emerald-500 bg-emerald-950/20 p-2 rounded"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-xs font-bold text-emerald-400 uppercase mb-1"
    }, "Good practice"), /*#__PURE__*/React.createElement("ul", {
      className: "text-sm text-slate-200 space-y-0.5"
    }, defibReview.good.map(function (g) {
      return /*#__PURE__*/React.createElement("li", {
        key: g
      }, "\u2713", " ", g);
    }))), defibReview.improve.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "border-l-4 border-red-500 bg-red-950/20 p-2 rounded"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-xs font-bold text-red-400 uppercase mb-1"
    }, "Areas for improvement"), /*#__PURE__*/React.createElement("ul", {
      className: "text-sm text-slate-200 space-y-0.5"
    }, defibReview.improve.map(function (g) {
      return /*#__PURE__*/React.createElement("li", {
        key: g
      }, "\u26A0", " ", g);
    })))), ventReview && /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-4 rounded-lg border border-cyan-700/60",
      "data-testid": "vent-feedback"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-white mb-1 flex items-center gap-2"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "wind",
      className: "w-4 h-4 text-cyan-400"
    }), " Ventilator feedback"), ventSim && /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-slate-400 mb-2"
    }, ventSim.name, " \xB7 ", ventSim.mode === 'assessment' ? 'Assessment' : 'Education', " mode"), ventReview.stats.length > 0 && /*#__PURE__*/React.createElement("ul", {
      className: "text-xs text-slate-300 mb-2 space-y-0.5"
    }, ventReview.stats.map(function (g) {
      return /*#__PURE__*/React.createElement("li", {
        key: g
      }, "\u2022", " ", g);
    })), ventReview.good.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "mb-2 border-l-4 border-emerald-500 bg-emerald-950/20 p-2 rounded"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-xs font-bold text-emerald-400 uppercase mb-1"
    }, "Good practice"), /*#__PURE__*/React.createElement("ul", {
      className: "text-sm text-slate-200 space-y-0.5"
    }, ventReview.good.map(function (g) {
      return /*#__PURE__*/React.createElement("li", {
        key: g
      }, "\u2713", " ", g);
    }))), ventReview.improve.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "mb-2 border-l-4 border-red-500 bg-red-950/20 p-2 rounded"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-xs font-bold text-red-400 uppercase mb-1"
    }, "Areas for improvement"), /*#__PURE__*/React.createElement("ul", {
      className: "text-sm text-slate-200 space-y-0.5"
    }, ventReview.improve.map(function (g) {
      return /*#__PURE__*/React.createElement("li", {
        key: g
      }, "\u26A0", " ", g);
    }))), ventReview.problems.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "border-l-4 border-amber-500 bg-amber-950/20 p-2 rounded"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-xs font-bold text-amber-400 uppercase mb-1"
    }, "Problems injected"), /*#__PURE__*/React.createElement("ul", {
      className: "text-sm text-slate-200 space-y-0.5"
    }, ventReview.problems.map(function (p, i) {
      return /*#__PURE__*/React.createElement("li", {
        key: i
      }, p.text);
    }))), /*#__PURE__*/React.createElement("p", {
      className: "text-[10px] text-slate-500 mt-2"
    }, "Targets are the simulator's teaching targets for this scenario, not a guideline.")), hasMarkSheet && /*#__PURE__*/React.createElement(MS.DebriefMarkSheet, {
      scenario: scenario,
      marks: sheetMarks,
      onMark: markSheetItem
    }), skillMarks.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-4 rounded-lg border border-slate-700",
      "data-testid": "debrief-skills"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-white mb-2"
    }, "Skills checklist"), /*#__PURE__*/React.createElement("ul", {
      className: "space-y-1"
    }, skillMarks.map(function (_ref9) {
      var _ref0 = _slicedToArray(_ref9, 2),
        k = _ref0[0],
        v = _ref0[1];
      return /*#__PURE__*/React.createElement("li", {
        key: k,
        className: "flex items-center justify-between text-sm"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-slate-200"
      }, k), /*#__PURE__*/React.createElement("span", {
        className: "font-bold ".concat(v ? 'text-emerald-400' : 'text-red-400')
      }, v ? 'Observed' : 'Needs improvement'));
    }))), /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-4 rounded-lg border border-slate-700"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-white mb-2"
    }, "Performance Summary"), score === null ? /*#__PURE__*/React.createElement("div", {
      className: "mb-4 text-sm text-slate-400"
    }, ventSim ? 'A Ventilator Sim is not scored against learning objectives: the ventilator feedback, the obs graph, the event log and your notes are the debrief.' : defibSim ? 'A Defib Sim is not scored against learning objectives: the Defib Sim feedback, the obs graph, the event log and your notes are the debrief.' : isQuickSim ? 'Quick Sim has no scenario, so there are no learning objectives to score. The obs graph, the event log and your notes are the debrief.' : 'This session declared no learning objectives, so there is nothing to score.') : /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-4 mb-4 flex-wrap"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "text-4xl font-bold text-sky-400"
    }, score, "%"), /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] uppercase tracking-wider text-slate-400 font-bold"
    }, "Fully met")), partialCount > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "text-4xl font-bold text-amber-400"
    }, partialScore, "%"), /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] uppercase tracking-wider text-slate-400 font-bold"
    }, "With partial credit")), /*#__PURE__*/React.createElement("div", {
      className: "text-sm text-slate-400"
    }, "Objectives Met: ", objectivesMet, "/", objectivesTotal, partialCount > 0 && /*#__PURE__*/React.createElement("span", {
      className: "text-amber-400"
    }, " \xB7 ", partialCount, " partly done"))), shockTotal > 0 && /*#__PURE__*/React.createElement("div", {
      className: "mb-4 bg-slate-900 border border-red-900/60 rounded p-3",
      "data-testid": "debrief-defib"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "text-xs font-bold text-red-400 uppercase mb-2 flex items-center gap-1"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "zap",
      className: "w-3 h-3"
    }), " Defibrillation"), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 sm:grid-cols-4 gap-2"
    }, [['Shocks', shockTotal, '', ''], ['Counted towards ROSC', defibMetrics.shockableShocks || 0, '', 'Shocks into a shockable rhythm, not counting a shock stacked within 5 s of the last'], ['Cumulative', defibMetrics.totalEnergy || 0, 'J'], ['Last energy', (_defibMetrics$lastEne2 = defibMetrics.lastEnergy) !== null && _defibMetrics$lastEne2 !== void 0 ? _defibMetrics$lastEne2 : '--', 'J']].map(function (_ref1) {
      var _ref10 = _slicedToArray(_ref1, 4),
        lbl = _ref10[0],
        val = _ref10[1],
        unit = _ref10[2],
        tip = _ref10[3];
      return /*#__PURE__*/React.createElement("div", {
        key: lbl,
        className: "bg-slate-800 rounded p-2 text-center border border-slate-700",
        title: tip || undefined
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-[10px] font-bold uppercase text-slate-400"
      }, lbl), /*#__PURE__*/React.createElement("div", {
        className: "text-lg font-mono font-bold text-white"
      }, val, /*#__PURE__*/React.createElement("span", {
        className: "text-[9px] text-slate-400 ml-0.5"
      }, unit)));
    })), /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] text-slate-400 mt-2"
    }, "Device left in ", String(defibMetrics.mode || 'monitor').toUpperCase(), " mode", defibMetrics.syncMode ? ', SYNC armed' : '', ".", ' ', conversionEvents.length, " rhythm transition", conversionEvents.length === 1 ? '' : 's', " recorded."), shockEvents.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "mt-2 max-h-28 overflow-y-auto space-y-1"
    }, shockEvents.map(function (l, i) {
      return /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "flex gap-2 text-[11px]"
      }, /*#__PURE__*/React.createElement("span", {
        className: "font-mono text-slate-400 flex-none"
      }, l.simTime), /*#__PURE__*/React.createElement("span", {
        className: "text-red-300"
      }, l.msg));
    }))), objectivesTotal > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h4", {
      className: "text-sm font-bold text-white mb-2 uppercase"
    }, "Learning Objectives"), /*#__PURE__*/React.createElement("ul", {
      className: "space-y-2"
    }, allObjectives.map(function (obj, i) {
      var r = statusOf(obj);
      var icon = r.status === 'met' ? 'check-square' : r.status === 'partial' ? 'minus-square' : 'square';
      var colour = r.status === 'met' ? 'text-emerald-500' : r.status === 'partial' ? 'text-amber-400' : 'text-slate-400';
      return /*#__PURE__*/React.createElement("li", {
        key: i,
        className: "text-sm text-slate-300"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex items-start gap-2"
      }, r.facilitatorJudged ? /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: function onClick() {
          return toggleObjective(obj);
        },
        "aria-pressed": r.status === 'met',
        "aria-label": "".concat(r.status === 'met' ? 'Untick' : 'Tick', ": ").concat(obj),
        "data-testid": "objective-tick",
        title: "Not scored from actions: tick if the team demonstrated it",
        className: "flex-none mt-0.5 rounded focus:outline-none focus:ring-2 focus:ring-sky-500"
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: icon,
        className: "".concat(colour, " w-4 h-4")
      })) : /*#__PURE__*/React.createElement(Lucide, {
        icon: icon,
        className: "".concat(colour, " w-4 h-4 flex-none mt-0.5")
      }), /*#__PURE__*/React.createElement("span", {
        className: "flex-1"
      }, obj), r.status === 'partial' && /*#__PURE__*/React.createElement("span", {
        className: "text-[9px] uppercase font-bold text-amber-300 border border-amber-700 bg-amber-950/40 rounded px-1 py-0.5 flex-none"
      }, "partly done"), r.facilitatorJudged && /*#__PURE__*/React.createElement("span", {
        className: "text-[9px] uppercase font-bold text-slate-400 border border-slate-700 rounded px-1 py-0.5 flex-none"
      }, "facilitator tick")), r.components && r.components.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "ml-6 mt-1 flex flex-wrap gap-1"
      }, r.components.map(function (c) {
        return /*#__PURE__*/React.createElement("span", {
          key: c.key,
          className: "text-[10px] px-1.5 py-0.5 rounded border font-medium ".concat(c.met ? 'text-emerald-300 border-emerald-800 bg-emerald-950/40' : 'text-slate-400 border-slate-700 bg-slate-900')
        }, c.met ? "\u2713" : "\u2715", " ", c.label);
      })));
    })), /*#__PURE__*/React.createElement("p", {
      className: "text-[10px] text-slate-400 mt-2"
    }, "A multi-component objective counts as met only when every component was done. Partly-done objectives show the missing component above and are excluded from the fully-met score. Objectives marked \u201Cfacilitator tick\u201D (recognition, judgement, communication) are not scored from actions: tick the box if the team demonstrated it."))), !isQuickSim && /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-4 rounded-lg border border-amber-600/50"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-amber-400 mb-1 flex items-center gap-2"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "flag",
      className: "w-4 h-4"
    }), " Sequence Deviations"), /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-slate-400 mb-3"
    }, "Actions performed before their usual prerequisites were in place. Nothing was blocked \u2014 these are discussion points, not errors by definition. ", deviations.length, " deviation", deviations.length === 1 ? '' : 's', "; ", significanceCount, " other flagged event", significanceCount === 1 ? '' : 's', " (arrests, shocks and manual flags) are highlighted in the timeline but are not deviations."), deviations.length === 0 ? /*#__PURE__*/React.createElement("div", {
      className: "text-sm text-slate-400"
    }, "No sequence deviations recorded.") : /*#__PURE__*/React.createElement("ul", {
      className: "space-y-2"
    }, deviations.map(function (entry, i) {
      return /*#__PURE__*/React.createElement("li", {
        key: i,
        className: "bg-slate-900 border border-amber-700/40 rounded p-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex justify-between gap-2 items-baseline"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-sm font-bold text-amber-200"
      }, entry.deviation.label || entry.deviation.action), /*#__PURE__*/React.createElement("span", {
        className: "font-mono text-xs text-slate-400"
      }, entry.simTime)), /*#__PURE__*/React.createElement("div", {
        className: "text-xs text-slate-300 mt-0.5"
      }, "Not in place: ", entry.deviation.missing.join(', ')));
    }))), /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-4 rounded-lg border border-slate-700"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-white mb-2"
    }, "Instructor Notes"), /*#__PURE__*/React.createElement("textarea", {
      value: instructorNotes,
      onChange: function onChange(e) {
        return setInstructorNotes(e.target.value);
      },
      className: "w-full h-32 bg-slate-900 border border-slate-600 rounded p-2 text-white text-sm",
      placeholder: "Add feedback notes here..."
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col bg-slate-800 rounded-lg border border-slate-700 overflow-hidden min-w-0 max-lg:max-h-[75vh]",
      "data-testid": "debrief-log"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap border-b border-slate-700 bg-slate-900 p-2 gap-2"
    }, ['all', 'actions', 'manual', 'shocks', 'rhythm', 'system'].map(function (f) {
      return /*#__PURE__*/React.createElement("button", {
        key: f,
        onClick: function onClick() {
          return setFilter(f);
        },
        className: "px-3 py-1 rounded text-xs font-bold uppercase ".concat(filter === f ? 'bg-sky-600 text-white' : 'bg-slate-800 text-slate-400 hover:bg-slate-700')
      }, f);
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex-1 overflow-y-auto p-4 max-md:p-3 space-y-2 min-h-0"
    }, filteredLog.map(function (entry, i) {
      return /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "flex gap-3 text-sm border-b border-slate-700/50 pb-1 ".concat(entry.flagged ? 'bg-amber-900/10 p-1 rounded' : '')
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-slate-400 font-mono w-16 max-md:w-12 flex-shrink-0"
      }, entry.simTime), /*#__PURE__*/React.createElement("span", {
        className: "flex-grow ".concat(entry.type === 'danger' ? 'text-red-400 font-bold' : entry.type === 'success' ? 'text-emerald-400 font-bold' : 'text-slate-300')
      }, entry.flagged && /*#__PURE__*/React.createElement(Lucide, {
        icon: "flag",
        className: "inline w-3 h-3 text-amber-500 mr-1"
      }), entry.msg));
    })))));
  };
  window.DebriefScreen = DebriefScreen;
})();